import Swiper from "swiper";
import { A11y, Autoplay, EffectFade, Pagination } from "swiper/modules";
import "@styles/components/slider.css";

document.querySelectorAll(".element-quotes.as-image").forEach((el) => {
  const numSlides = el.querySelectorAll(".quote-text-slider .swiper-slide").length;

  if (numSlides < 2) {
    return;
  }

  const imageSwiper = new Swiper(el.querySelector(".quote-image-slider .swiper"), {
    modules: [A11y, EffectFade],
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    loop: true,
    speed: 1000,
    allowTouchMove: false,
  });

  new Swiper(el.querySelector(".quote-text-slider .swiper"), {
    modules: [A11y, Autoplay, EffectFade, Pagination],
    autoplay: {
      delay: 6000,
      pauseOnMouseEnter: true,
    },
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    loop: true,
    speed: 1000,
    pagination: {
      el: el.querySelector(".slider-pagination"),
      clickable: true,
    },
    on: {
      activeIndexChange: (swiper) => {
        imageSwiper.slideTo(swiper.realIndex);
      },
    },
  });
});

document.querySelectorAll(".element-quotes.as-double-image").forEach((el) => {
  const container = el.querySelector(".swiper");

  new Swiper(container, {
    modules: [A11y, Autoplay, EffectFade, Pagination],
    autoplay: {
      delay: 6000,
      pauseOnMouseEnter: true,
    },
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    loop: true,
    speed: 1000,
    pagination: {
      el: el.querySelector(".slider-pagination"),
      clickable: true,
    },
  });
});

document.querySelectorAll(".element-quotes.as-text").forEach((el) => {
  const container = el.querySelector(".swiper");

  new Swiper(container, {
    modules: [A11y, Autoplay, EffectFade, Pagination],
    autoplay: {
      delay: 6000,
      pauseOnMouseEnter: true,
    },
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    loop: true,
    speed: 1000,
    pagination: {
      el: el.querySelector(".slider-pagination"),
      clickable: true,
    },
  });
});
